"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Agent_1 = __importDefault(require("./Agent"));
class RemoteAgent extends Agent_1.default {
    constructor(agentId) {
        super(agentId);
    }
}
exports.default = RemoteAgent;
//# sourceMappingURL=RemoteAgent.js.map